<div *ngIf="historyPaginated && historyPaginated.length" class="bmc-sync-data">
  <strong class="bz-space--stack-s">{{'SYNC_DATA.TITLE_HISTORY_IMPORT' | translate}}</strong>
  <div>
    <table class="bz-table">
      <thead>
        <tr>
          <th class="bz-table__cell bmc-sync-data__td-left">
            {{'SYNC_DATA.USERNAME' | translate}}
          </th>
          <th class="bz-table__cell bmc-sync-data__td-left">
            {{'SYNC_DATA.STATUS' | translate}}
          </th>
          <th class="bz-table__cell bmc-sync-data__td-left">
            {{'SYNC_DATA.IMPORTED_DATE' | translate}}
          </th>
          <th class="bz-table__cell bmc-sync-data__td-left">
            {{'SYNC_DATA.IMPORTED_ENTITIES' | translate}}
          </th>
          <th class="bz-table__cell bmc-sync-data__td-center">
            {{'SYNC_DATA.DOWNLOAD' | translate}}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let his of historyPaginated">

          <td class="bz-table__cell">
            {{his.userName}}
          </td>
          <td class="bz-table__cell" [ngSwitch]="his.status">
            <div *ngSwitchCase="'NotStarted'">
              <bzg-icon [nameIcon]="'icon-info-strong'" [color]="'info'"></bzg-icon>
            </div>
            <div *ngSwitchCase="'InProgress'">
              <bzg-icon [nameIcon]="'icon-info-strong'" [color]="'info'"></bzg-icon>
            </div>
            <div *ngSwitchCase="'Error'">
              <bzg-icon [nameIcon]="'icon-error'" [color]="'error'" [bzgTooltip]="his.errorMessage"
                bzgTooltipPosition="above"></bzg-icon>
            </div>
            <div *ngSwitchCase="'Done'">
              <bzg-icon [nameIcon]="'icon-check-mark'" [color]="'success'"></bzg-icon>
            </div>
          </td>
          <td class="bz-table__cell">
            {{ his.timestamp | userTimezoneFormat: 1 }}
          </td>
          <td class="bz-table__cell">
            {{his.uploadDescription}}
          </td>
          <td class="bz-table__cell bmc-sync-data__td-center">
            <bz-loading [size]="'s'"
              *ngIf="his.status === 'NotStarted' || his.status === 'InProgress'"></bz-loading>
            <a [href]="his.fullPath" download="his.fileName" *ngIf="his.status === 'Done'">
              <bzg-icon [nameIcon]="'icon-download'" [color]="'active'">
              </bzg-icon>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="bz-table-pagination">
    <bzg-paginator [pageSize]="pageSize" [totalItems]="_history ? _history.length : 5"
      (paginationChanged)="onPaginationEvent($event)" [pageSizeOptions]="[5]">
    </bzg-paginator>
  </div>
</div>
